import { get } from '../utils/axios'


export const getBanksAPI = async () => {
  return await get('banks')
}
